"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hermes = void 0;
exports.hermes = {
    router: '0x2d4F788fDb262a25161Aa6D6e8e1f18458da8441',
};
